module.exports = __webpack_public_path__ + "static/media/dodoexchange.2de7ab26.png";